import { render, staticRenderFns } from "./MenuTest.vue?vue&type=template&id=135fccdd&"
import script from "./MenuTest.vue?vue&type=script&lang=js&"
export * from "./MenuTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports